export const PROJECTS_ROUTE_CONST = 'projects';

/** Router link to the projects list page (`/projects`). */
export const PROJECTS_LIST_ROUTE = ['/', PROJECTS_ROUTE_CONST] as const;

/**
 * Router link to a single project's detail page (`/projects/:projectId`, Q28).
 *
 * @param projectId - the project to open.
 * @returns the router commands array for that project's detail page.
 */
export function ktProjectDetailRoute(projectId: string): string[] {
  return [...PROJECTS_LIST_ROUTE, projectId];
}
